import { Client } from "./_clientService";

async function getTranslation({ isoCode }) {
  let path = "/misc/translations";
  if (isoCode) path += "?isoCode=" + isoCode;
  const resp = await new Client({ path }).get();

  return resp;
}

export { getTranslation}
